module.exports = __webpack_public_path__ + "static/media/prepaid_b0b.97683b3c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/prepaid_b0b.png
// module id = 740
// module chunks = 21